<template>
  <div class="content">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('chat.teachingPlan.back') }}</span>
    </div>
    <div class="main">
      <div class="left" ref="left">
        <CourseGenerationConfig type="teaching" ref="CourseGenerationConfig" :outputCompleted="outputCompleted" @ok="generate" @clear="clearForm" />
      </div>
      <!-- 输入区域 -->
      <div class="right" ref="right">
        <div v-if="tempMessage == ''" class="loading" style="color: #F59363">
          <img src="@/assets/img/ai_loading.png" class="loading-icon" style="margin-bottom: 12px;" alt="" srcset="" />
          {{ $t('chat.teachingPlan.waitingGeneration') }}
        </div>
        <div v-else>
          <div class="outline" ref="outline">
            {{ tempMessage }}
          </div>
          <div class="stop-text" v-if="isStop">{{ $t('chat.teachingPlan.generationStopped') }}</div>
          <div class="stop" type="link" v-if="!outputCompleted" @click="stopGenerate">
            {{ $t('chat.teachingPlan.stopGeneration') }}
          </div>
          <div class="action" v-else>
            <div class="operation">
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t('chat.teachingPlan.regenerate') }}</span>
                </template>
                <div class="list" @click="reload">
                  <img src="@/assets/icons/icon_reload@2x.png" alt="">
                </div>
              </a-tooltip>
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ $t('chat.teachingPlan.download') }}</span>
                </template>
                <div class="list" @click="downloadFile">
                  <img src="@/assets/icons/icon_download@2x.png" alt="">
                </div>
              </a-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SSE } from '@/utils/sse.js'
import CourseGenerationConfig from '@/components/CourseGenerationConfig/index.vue'
import { getAIChatHistoryDetail } from '@/api/aiApp.js'
import { teachingPlan } from '@/data/app.js'

export default {
  name: 'GenerationTeachingPlan',
  components: {
    CourseGenerationConfig
  },
  data() {
    return {
      outlineMessage: '',
      taskId: '',
      tempMessage: '',
      outputCompleted: true,
      isStop: false,
      fileList: []
    }
  },
  methods: {
    generate(inputParams, again) {
      this.changeLeftStyle()
      this.newMessage = '' // 清空输入框
      this.outputCompleted = false
      this.isStop = false
      let params
      if (again) {
        params = this.lastParams
      } else {
        params = {
          query: '请根据要求输入',
          inputs: inputParams.inputs,
          response_mode: 'streaming',
          conversation_id: '',
          files: inputParams.files
        }
        this.lastParams = params
      }

      this.source = new SSE('/ai_app/chat-messages', {
        headers: {
          'X-App-Id': teachingPlan.id
        },
        payload: JSON.stringify(params),
        method: 'POST'
      })
      this.tempMessage = ''
      this.source.addEventListener('message', e => {
        const res = JSON.parse(e.data)
        if (res.event === 'message') {
          this.tempMessage += res.answer
          this.taskId = res.task_id
          // 添加滚动条自动滚动
          this.$nextTick(() => {
            const contentDiv = this.$refs.outline.querySelector('.content')
            if (contentDiv) {
              contentDiv.scrollTop = contentDiv.scrollHeight
            }
          })
        } else if (res.event === 'message_end') {
          this.outputCompleted = true
        }
      })
      this.source.addEventListener('error', event => {})
    },
    changeLeftStyle() {
      this.$refs.left.style.width = '300px'
      this.$refs.right.style.flex = 1
      this.$refs.right.style.border = '1px solid #e7e7e7'
    },
    stopGenerate() {
      if (this.source) {
        this.outputCompleted = true
        this.isStop = true
        this.source.close()
      }
    },
    reload() {
      this.outlineMessage = ''
      this.tempMessage = ''
      this.outputCompleted = false
      this.isStop = false
      this.taskId = null
      this.generate({}, true)
    },
    downloadFile() {
      if (!this.tempMessage) return
      // 生成最基础的 Word 文档内容
      const header = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><w:wordDocument xmlns:w="http://schemas.microsoft.com/office/word/2003/wordml"><w:body><w:p><w:r><w:t>'
      const footer = '</w:t></w:r></w:p></w:body></w:wordDocument>'
      const content = header + this.tempMessage.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '</w:t></w:r></w:p><w:p><w:r><w:t>') + footer
      const blob = new Blob([content], { type: 'application/msword' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = this.$t('chat.teachingPlan.downloadFileName')
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    clearForm() {
      // 清空文件列表
      this.fileList = []
      // 清空生成的内容
      // this.tempMessage = ''
      // this.outlineMessage = ''
      // this.outputCompleted = false
      // // 清空任务ID
      // this.taskId = ''
      // 重置布局
      // this.$refs.left.style.width = '500px'
      // this.$refs.right.style.flex = 0
      // this.$refs.right.style.border = 'none'
    },
    back() {
      this.$router.back()
    },
    async getData() {
      const res = await getAIChatHistoryDetail({
        conversation_id: this.conversationId,
        limit: 100
      }, {
        'X-App-Id': this.selectedAppId
      })
      console.log(res)
      if (res.data.length > 0) {
        this.historyDetail = res.data[0]
        this.tempMessage = this.historyDetail.answer
        this.$refs.CourseGenerationConfig.initData(this.historyDetail.inputs)
        this.$refs.CourseGenerationConfig.selectKnowledgeObj.id = this.historyDetail.knowledge_id
        this.$refs.CourseGenerationConfig.fileList = this.historyDetail.files || []
        this.changeLeftStyle()
      }
    }
  },
  mounted() {
    this.conversationId = this.$route.query.conversationId
    this.selectedAppId = this.$route.query.id
    if (this.selectedAppId) {
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 18px 21px;
  .main {
    display: flex;
    justify-content: center;
    height: calc(100vh - 180px);
    border-radius: 10px;
    .left {
      width: 500px;
      height: 100%;
      padding-right: 15px;
      padding-top: 30px;
      padding-left: 10px;
      position: relative;
    }
    .right {
      width: 0px;
      // flex: 1;
      height: 100%;
      background: #fafafa;
      display: flex;
      border: none;
      border-radius: 10px;
      // justify-content: center;
      align-items: center;
      overflow: hidden;
      > div {
        width: 100%;
        height: 100%;
        padding: 26px 33px;
        overflow: auto;
      }
      .outline {
        font-size: 16px;
        color: #000000;
        margin-bottom: 17px;
        white-space: pre-line;
        padding: 20px;
      }
      .stop-text{
        font-weight: 600;
        font-size: 12px;
        color: #9E9E9E;
        padding-bottom: 4px;
        padding-left: 20px;
      }
      .stop{
        min-width: 80px;
        padding: 0 10px;
        width: fit-content;
        height: 30px;
        border-radius: 15px;
        border: 1px solid #B5C5DA;
        margin-bottom: 12px;
        font-weight: 600;
        font-size: 12px;
        color: #678BB8;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #0d2340;
        font-size: 14px;
        flex-direction: column;
        font-weight: bold;
        img {
          width: 76px;
        }
      }
      .action {
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        margin-top: 10px;
        .operation{
          display: flex;
          .list{
            width: 25px;
            height: 25px;
            margin-left: 20px;
            cursor: pointer;
            overflow: hidden;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .list:hover{
            // img{
            //   transform: translateY(-60px);
            //   filter: drop-shadow(#FF9E3F 0 60px);
            // }
          }
        }
        // img {
        //   width: 25px;
        //   margin-left: 20px;
        //   cursor: pointer;
        // }
        /deep/ .ant-btn {
          color: #ff8d29;
          background-color: #fff;
          border-color: #ff8d29;
        }
      }
    }
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}

.completed {
  h2,
  h3 {
    margin-bottom: 0;
    padding-left: 2px;
    cursor: pointer;
    &:hover {
      background-color: #f0f0f0;
      .action-buttons {
        display: block !important;
      }
    }
    /deep/ .ant-input {
      width: 100%;
      font-size: inherit;
      font-weight: inherit;
      height: 25px;
    }
    .title {
      // width: 500px;
    }
  }
  h2 {
    height: 40px;
    line-height: 40px;
    /deep/ .ant-input {
      height: 30px;
    }
  }
  h3 {
    height: 30px;
    line-height: 30px;
    // padding: 2px 0px;
  }
}

// .title-text {
//   cursor: pointer;
//   &:hover {
//     background-color: #f0f0f0;
//   }
// }

// .loading-icon {
//   animation: pulse 1.5s ease-in-out infinite;
// }

// @keyframes pulse {
//   0% { 
//     transform: scale(0.95);
//     opacity: 0.8;
//   }
//   50% {
//     transform: scale(1.05);
//     opacity: 1;
//   }
//   100% {
//     transform: scale(0.95);
//     opacity: 0.8;
//   }
// }
</style>
